document.addEventListener("DOMContentLoaded", function () {
  initPricingToggles();
  addScrollAnimations();
  initFaqAccordions();
  initPlanComparison();
});

function initPricingToggles() {
  const pricingCards = document.querySelectorAll(
    ".relative.bg-white.rounded-2xl"
  );

  pricingCards.forEach((card) => {
    card.addEventListener("mouseenter", function () {
      this.classList.add("shadow-lg");

      const button = this.querySelector('a[href="#"]');
      if (button) {
        button.classList.add("pulse-animation");
      }
    });

    card.addEventListener("mouseleave", function () {
      this.classList.remove("shadow-lg");

      const button = this.querySelector('a[href="#"]');
      if (button) {
        button.classList.remove("pulse-animation");
      }
    });
  });
}

function addScrollAnimations() {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');

  anchorLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const targetId = this.getAttribute("href");
      if (targetId === "#") return;

      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        const headerHeight = 80;
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    });
  });

  if (window.location.hash) {
    const targetElement = document.querySelector(window.location.hash);
    if (targetElement) {
      setTimeout(() => {
        const headerHeight = 80;
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }, 100);
    }
  }
}

function initFaqAccordions() {
  if (typeof Alpine === "undefined") {
    const faqButtons = document.querySelectorAll(".space-y-6 button");

    faqButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const content = this.nextElementSibling;
        const icon = this.querySelector("svg");

        faqButtons.forEach((otherButton) => {
          if (otherButton !== button) {
            const otherContent = otherButton.nextElementSibling;
            const otherIcon = otherButton.querySelector("svg");

            if (otherContent && otherContent.classList.contains("active")) {
              otherContent.classList.remove("active");
              otherContent.style.maxHeight = null;
              otherIcon.classList.remove("rotate-180");
            }
          }
        });

        if (content) {
          if (content.classList.contains("active")) {
            content.classList.remove("active");
            content.style.maxHeight = null;
            icon.classList.remove("rotate-180");
          } else {
            content.classList.add("active");
            content.style.maxHeight = content.scrollHeight + "px";
            icon.classList.add("rotate-180");
          }
        }
      });
    });
  }
}

function initPlanComparison() {
  const comparisonRows = document.querySelectorAll(
    ".divide-y.divide-gray-100 > div"
  );

  comparisonRows.forEach((row) => {
    row.addEventListener("mouseenter", function () {
      this.classList.add("bg-gray-50/80");
    });

    row.addEventListener("mouseleave", function () {
      this.classList.remove("bg-gray-50/80");
    });
  });

  const featureNames = document.querySelectorAll(
    ".divide-y.divide-gray-100 > div > div:first-child"
  );

  featureNames.forEach((feature) => {
    feature.addEventListener("mouseenter", function () {
      this.classList.add("text-primary", "font-medium");
    });

    feature.addEventListener("mouseleave", function () {
      if (!this.classList.contains("font-medium-persistent")) {
        this.classList.remove("text-primary", "font-medium");
      }
    });
  });
}
